<template>
  <div class="navbar navbar--footer">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="navbar-nav-link" @click.prevent="openRequisitesModal">
          {{ $t('footer.requisites') }}
        </a>
      </li>
      <li class="nav-item">
        <a class="navbar-nav-link" href="https://saskaita123.lt/privatumo-politika" target="_blank">
          {{ $t('footer.policy') }}
        </a>
      </li>
      <li class="nav-item">
        <a class="navbar-nav-link" href="https://saskaita123.lt/naudojimosi-salygos" target="_blank">
          {{ $t('footer.use_terms') }}
        </a>
      </li>
    </ul>

    <requisites-info-modal v-if="requisitesModalVisible" v-model="requisitesModalVisible"/>
  </div>
</template>

<script setup>
  import { defineAsyncComponent, ref } from 'vue';

  const RequisitesInfoModal = defineAsyncComponent(() => import('@/modals/info/requisites/manage'));

  const requisitesModalVisible = ref(false);

  function openRequisitesModal() {
    requisitesModalVisible.value = true;
  }
</script>
